// extracted by mini-css-extract-plugin
export var quillEditor = "_m7-1";
export var variable = "_m7-0";